/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import { React, useEffect, useState } from 'react';
import Typography from "@material-ui/core/Typography";
import '../../css/views/CreateResponseJsonView.css'
import '../../css/views/Views.css'
import '../../css/Common.css'
import "../../css/views/ResponseJsonView.css"
import Fade from '@material-ui/core/Fade';
import HttpService from '../../js/service/HttpService.js';


export default function SurveyResponseView({details,langJson}){
    
    const transform = (data) => {    

        const {questions} = data;

        let days = {};
        
        for (const question of questions){          

            if(days[question.dayOffset] === undefined){
                days[question.dayOffset] = [question];
            }
            else{
                days[question.dayOffset].push(question);
            }  
        }

        return days;

    }
    
    let surveyResponse = [];

    if(details){
        surveyResponse = transform(details);
    }


    /**
     * Html
     */
    return (
        <>  
            <Fade in={true}>
                <div className='views-common-paper'>
                        <div className='views-common-header'>
                            <Typography variant="h5" style={{ marginTop: "10px" }} gutterBottom>
                                    Response View
                            </Typography>  
                        </div>
                        {Object.keys(surveyResponse).map(res => (
                            <>
                                <h2>Day: {res}</h2>
                                {surveyResponse[res].map(question => (
                                    <>
                                        <p><strong>Question: {langJson[question.questionId]} ({question.dateTime})</strong></p>
                                        {question.answers.map(answer => (
                                            <>
                                            <p>&emsp;Answer: {langJson[answer.valueEnum]}</p>
                                            </>
                                        ))}
                                    </>
                                ))}

                            </>
                        ))}
                    </div> 
            </Fade>              
        </>
    );
}
